import React, { useEffect } from "react";
import { Modal, Form, Input, InputNumber, Select, message } from "antd";
import { createMenu, updateMenu } from "../../actions/merchant_actions";
import { useParams } from "react-router-dom";

const { Option } = Select;

const MenuFormModal = ({
  visible,
  setVisible,
  initialValues,
  refetchMenus,
}) => {
  const { accUrn } = useParams();
  const [form] = Form.useForm();

  // Populate form when editing
  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue({
        name: initialValues.data.name,
        currency_code: initialValues.data.currency_code,
        minimum_payment_amount: initialValues.data.minimum_payment_amount,
        maximum_payment_amount: initialValues.data.maximum_payment_amount,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      if (initialValues?.urn) {
        // Edit mode
        await updateMenu({
          account_urn: accUrn,
          menuUrn: initialValues.urn,
          data: values,
        });
        message.success("Menu updated successfully!");
      } else {
        // Create mode
        await createMenu({
          account_urn: accUrn,
          data: values,
        });
        message.success("Menu created successfully!");
      }

      refetchMenus?.();
      setVisible(false);
      form.resetFields();
    } catch (err) {
      const msg =
        err?.response?.data?.message || err?.message || "Something went wrong!";
      message.error(msg);
    }
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  return (
    <Modal
      title={initialValues ? "Edit Menu" : "Add New Menu"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={initialValues ? "Update" : "Submit"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ currency_code: "GBP" }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input menu name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Currency Code"
          name="currency_code"
          rules={[{ required: true, message: "Please select currency code!" }]}
        >
          <Select>
            <Option value="USD">USD</Option>
            <Option value="EUR">EUR</Option>
            <Option value="GBP">GBP</Option>
            <Option value="EGP">EGP</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Minimum Payment Amount"
          name="minimum_payment_amount"
          rules={[{ required: true, message: "Please enter minimum amount!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Maximum Payment Amount"
          name="maximum_payment_amount"
          rules={[{ required: true, message: "Please enter maximum amount!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MenuFormModal;
